import orderBy from 'lodash/orderBy'

import { NumberValue } from '../../../../utils'
import { InvoiceLineType } from '../../enums/invoiceLineType'
import type { DepositInvoiceVatRateGroup } from '../../types/invoiceDeposit/depositInvoiceVatRateGroup'
import type { InvoiceLine } from '../../types/invoices/invoiceLine'

// The package breaks rounding ties in favour of the earlier group, so the order must not depend on the quote line order
export const groupQuoteRowLinesByVatRate = (quoteLines: InvoiceLine[] = []): DepositInvoiceVatRateGroup[] => {
  const vatRateGroups: Record<string, DepositInvoiceVatRateGroup> = {}

  for (const line of quoteLines) {
    if (line.type === InvoiceLineType.Row && line.vatRateId) {
      const group = vatRateGroups[line.vatRateId] ?? {
        netTotal: 0,
        vatRateId: line.vatRateId,
        vatRatePercent: line.vatPct || 0,
      }

      vatRateGroups[line.vatRateId] = {
        ...group,
        netTotal: new NumberValue(group.netTotal).add(line.netTotal).getValue(),
      }
    }
  }

  return orderBy(Object.values(vatRateGroups), ['vatRatePercent', 'netTotal', 'vatRateId'], ['desc', 'desc', 'asc'])
}
